import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RolPlataforma } from '../../../../../core/models/novedades.models';
import { Postulacion } from '../../../../../core/models/postulaciones.models';
import { PasoFormulario, RevisionSeccionFormulario } from '../postulacion-formulario.models';

@Component({
  selector: 'app-postulacion-paso-revision-envio',
  imports: [CommonModule],
  templateUrl: './postulacion-paso-revision-envio.html',
  styleUrl: './postulacion-formulario-paso.shared.css',
})
export class PostulacionPasoRevisionEnvio {
  @Input() postulacion: Postulacion | null = null;
  @Input() rol: RolPlataforma = 'postulante';
  @Input() soloLectura = false;
  @Input() mensaje = '';
  @Input() seccionesRevision: RevisionSeccionFormulario[] = [];
  @Input() seccionesPendientes: RevisionSeccionFormulario[] = [];
  @Input() puedeEnviar = false;
  @Input() puedeEditar = false;
  @Input() enviando = false;
  @Output() solicitarEnvio = new EventEmitter<void>();
  @Output() navegarASeccion = new EventEmitter<PasoFormulario>();
  revisionEjecutada = false;

  emitirSolicitudEnvio(): void {
    this.solicitarEnvio.emit();
  }

  ejecutarRevision(): void {
    this.revisionEjecutada = true;
  }

  irASeccion(seccion: PasoFormulario): void {
    this.navegarASeccion.emit(seccion);
  }

  get puedeSolicitarEnvio(): boolean {
    return this.rol === 'postulante' && !this.soloLectura;
  }
}
